import { formatPluralCount } from '@/lib/formatters';
import { UserActionCode } from '../api';
import { UserActionMeta } from './types';

export const userActionMetaByCode: Record<UserActionCode, UserActionMeta> = {
  ADD_MCHD: {
    code: 'ADD_MCHD',
    description: 'Для выпуска кодов маркировки',
    title: 'Оформите МЧД',
    tone: 'red'
  },
  CONFIRM_SUPPLIER_DATA: {
    code: 'CONFIRM_SUPPLIER_DATA',
    description: 'Убедитесь, что данные актуальны',
    title: 'Проверьте данные поставщика',
    tone: 'red'
  },
  CONFIRM_RECEPTION_DECISION: {
    code: 'CONFIRM_RECEPTION_DECISION',
    description: 'Есть отклонения по товарам',
    title: 'Решите по приёмке',
    tone: 'red'
  },
  CONFIRM_SHIPMENT_DETAILS: {
    code: 'CONFIRM_SHIPMENT_DETAILS',
    description: 'Выберите место доставки в РФ',
    title: 'Подтвердите детали поставки',
    tone: 'red'
  },
  DECIDE_UNRELEASED_ITEM: {
    code: 'DECIDE_UNRELEASED_ITEM',
    descriptionResolver: (action) => {
      const details = action.details && 'type' in action.details && action.details.type === 'ITEM'
        ? action.details
        : null;
      const count = details?.item_count ?? 1;
      const isNotPaid = details?.customs_reason === 'NOT_PAID' || details?.customs_status === 'NOT_PAID';
      const prefix = isNotPaid
        ? 'Оформление остановлено: остаток не оплачен.'
        : 'Таможня не выпустила товары.';

      return `${prefix} Ожидают вашего решения: ${formatPluralCount({ value: count, variant: 'position' })}`;
    },
    title: 'Решите, что делать с товарами',
    tone: 'red'
  },
  PAY_ADVANCE: {
    code: 'PAY_ADVANCE',
    description: '30% для передачи в работу',
    title: 'Внесите аванс',
    tone: 'red'
  },
  PAY_CUSTOMS_SURCHARGE: {
    code: 'PAY_CUSTOMS_SURCHARGE',
    description: 'Возникла необходимость доплаты',
    title: 'Пополните баланс для таможни',
    tone: 'red'
  },
  PAY_SCHEDULED: {
    code: 'PAY_SCHEDULED',
    description: 'Для продолжения поставки',
    title: 'Оплатите по графику',
    tone: 'red'
  },
  PAY_SETTLEMENT: {
    code: 'PAY_SETTLEMENT',
    description: 'Итоговая сверка по поставке',
    title: 'Оплатите итоговые расчёты',
    tone: 'red'
  },
  SEND_QR_TO_SUPPLIER: {
    code: 'SEND_QR_TO_SUPPLIER',
    description: 'Для сдачи груза в Китае',
    title: 'Передайте QR поставщику',
    tone: 'red'
  },
  SET_ARRIVAL_DATE_AND_DROP_OFF_POINT: {
    code: 'SET_ARRIVAL_DATE_AND_DROP_OFF_POINT',
    description: 'Контакты, дата и точка приёмки',
    title: 'Проверьте данные поставщика',
    tone: 'red'
  },
  UPDATE_MCHD: {
    code: 'UPDATE_MCHD',
    description: 'Доверенность скоро истечёт',
    title: 'Оформите МЧД',
    tone: 'orange'
  },
  VIEW_RECEPTION_RESULTS: {
    code: 'VIEW_RECEPTION_RESULTS',
    description: 'Отклонений не выявлено',
    title: 'Посмотрите результаты приемки',
    tone: 'orange'
  }
};

export const getUserActionMeta = (code: UserActionCode): UserActionMeta => {
  return userActionMetaByCode[code];
};